import { put } from 'redux-saga/effects';

import api from './../api';

import { organizationFetchSuccess, organizationFetchFail, organizationSaveSuccess, organizationSaveFail, toastrAdd } from '../actions';

export function* organizationFetchSaga(action) {
  try {
    const response = yield api.organization.getOrganization(action.organizationID);

    if (!response.data.data.organization) {
      throw new Error('error in response');
    }
    yield put(organizationFetchSuccess(response.data.data.organization));
  } catch (error) {
    console.log(error);
    yield put(organizationFetchFail(error));
  }
}

export function* organizationSaveSaga(action) {

  try {

    // Save request
    const response = yield api.organization.saveOrganization(action.organizationID, action.data);

    // Update state
    yield put(organizationSaveSuccess(response.data.data.organization));
    // yield put(toastrAdd({details: 'Organisaation tiedot tallennettiin onnistuneesti.', title: 'Tiedot tallennettu', type: 'success'}));
    yield put(toastrAdd({details: action.translate('settings.organization_save_success_details'), title: action.translate('settings.organization_save_success_title'), type: 'success'}));

  } catch (response) {

    // Parse response errors
    let { errors, firstError } = yield response;

    // Set toastr notification
    yield put(toastrAdd({...firstError, type: 'error'}));

    // Update state
    let payload = yield {errors, firstError};
    yield put(organizationSaveFail(payload));
  }
}

